const resources = {
    endingIn: 'se terminant par',
    cardNumber: 'Numéro de carte',
    mm: 'MM',
    yy: 'AA',
    cvc: 'Code de sécurité',
    moreInfoPopover: 'Plus d’informations relatives au CVC',
    firstName: 'Prénom',
    lastName: 'Nom de famille',
    billingAddress: 'Adresse de facturation',
    useMyAddressRadio: 'Utiliser mon adresse de livraison',
    useDiffAddressRadio: 'Utiliser une adresse différente',
    saveCardCheckboxText: 'Enregistrer cette carte pour des achats futurs',
    makeDefaultCheckboxText: 'Définir comme carte par défaut',
    editCardTitle: 'Modifier une carte de crédit ou de débit',
    addNewCardTitle: 'Ajouter une carte de crédit ou de débit',
    cancelButton: 'Annuler',
    saveContinueButton: 'Enregistrer et continuer',
    debitCardDisclaimer: 'Cartes de débit Visa et Mastercard seulement',
    expirationDate: 'Date d’expiration',
    enterValidCardNumber: 'Veuillez entrer un numéro de carte valide.',
    useThisCard: 'Utiliser cette carte',
    cvv: 'CVV/CVC',
    updateExpiryDateError: 'Veuillez mettre à jour la date d’expiration'
};

export default function getResource(label) {
    return resources[label];
}
